import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CommentApprovalTypeStatus, CommentStatus, DropDownOptions } from "../components/ballot/comments/type";
const initialStatuses: CommentStatus = {
    Open: {
        id: '',
    },
    Resolved: {
        id: '',
    },
    UnResolved: {
        id: '',
    }
};
const commentApprovalinitialStatuses: CommentApprovalTypeStatus = {
    "Disapproved without comment": {
        "id": ""
    },
    "Unrelated to proposal": {
        "id": ""
    }
}
interface ballotCommentsData {
    ballotCommentRecords: Record<string, any>;
    ballotSearchComments: Record<string, any>;
    selectedComment: Record<string, any>;
    hasChildComment: boolean;
    activeIndex: number;
    allCommentApprovalTypeStatus: CommentApprovalTypeStatus;
    allCommentStatus: CommentStatus;
    recordId: string;
    parentBallotCommentID: string;
    isResponsed: boolean;
    commentStatusOptions: DropDownOptions[];
    commentApprovalStatusOptions: DropDownOptions[];
    allCommitteeMembersOptions: DropDownOptions[];
    commentTypeOptions: DropDownOptions[];
}
const initialState: ballotCommentsData = {
    ballotCommentRecords: [],
    ballotSearchComments: [],
    allCommentApprovalTypeStatus: commentApprovalinitialStatuses,
    allCommentStatus: initialStatuses,
    selectedComment: {},
    hasChildComment: false,
    activeIndex: 0,
    recordId: "",
    parentBallotCommentID: "",
    isResponsed: false,
    commentStatusOptions: [],
    commentApprovalStatusOptions: [],
    allCommitteeMembersOptions: [],
    commentTypeOptions: []
}
const ballotCommentsSlice = createSlice({
    name: 'ballotcomments',
    initialState,
    reducers: {
        updateBallotCommentRecords: (state,
            action: PayloadAction<Record<string, any>>) => {
            state.ballotCommentRecords = action.payload.value;
        },
        updateBallotSearchComments: (state,
            action: PayloadAction<Record<string, any>>) => {
            state.ballotSearchComments = action.payload.value;
        },
        updateCommentApprovalTypeStatus: (state,
            action: PayloadAction<Record<string, any>>) => {
            state.commentApprovalStatusOptions = action.payload.optionsValue
            state.allCommentApprovalTypeStatus = action.payload.value;
        },
        updateAllCommentStatus: (state,
            action: PayloadAction<Record<string, any>>) => {
            state.commentStatusOptions = action.payload.optionsValue
            state.allCommentStatus = action.payload.value;
        },
        updateAllCommitteeMembers: (state,
            action: PayloadAction<Record<string, any>>) => {
            state.allCommitteeMembersOptions = action.payload.optionsValue
        },
        updateCommentType: (state,
            action: PayloadAction<Record<string, any>>) => {
            state.commentTypeOptions = action.payload.optionsValue
        },
        updateBallotSelectedComment: (state,
            action: PayloadAction<Record<string, any>>) => {
            state.selectedComment = action.payload.value;
        },
        updateBallotHasEditPermission: (state,
            action: PayloadAction<Record<string, any>>) => {
            state.hasChildComment = action.payload.value;
        },
        updateBallotCommentRecordIndex: (state,
            action: PayloadAction<Record<string, any>>) => {
            state.activeIndex = action.payload.value;
            state.recordId = action.payload.id;
        },
        updateParentBallotCommentId: (state,
            action: PayloadAction<Record<string, any>>) => {
            state.parentBallotCommentID = action.payload.id;
        },
        fetchResponse: (state,
            action: PayloadAction<Record<string, any>>) => {
            state.isResponsed = action.payload.value;
        },
        reset: (state) => {
            state.ballotCommentRecords = [];
            state.ballotSearchComments = [];
            state.selectedComment = {};
            state.hasChildComment = false;
            state.activeIndex = 0;
            state.parentBallotCommentID = "";
            state.isResponsed = false;
        },
    }
});
export const ballotcomments = ballotCommentsSlice.actions
export default ballotCommentsSlice.reducer